import moment from 'moment';
import React from 'react';
import { Form, Modal } from "react-bootstrap";
import { Controller, useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingButtonWithForm from '../../components/LoadingButtonWithForm';
import SearchSelect from '../../components/SearchSelect';
import { responseError } from '../../helpers/responseHandler';
import { useGetSelectDriversQuery } from '../../redux/services/DriverService';
import { useAddJobMutation, useEditJobMutation } from '../../redux/services/JobService';
import { convertToFormData, sweetAlert } from '../../utils';
import { useAddDocMutation, useEditDocMutation } from '../../redux/services/DocService';

const DocAddModal = ({ show, handleClose, isEdit }) => {
    const navigate = useNavigate()
    const params = useParams()
    // const { state: { isEdit } } = useLocation()
    console.log(isEdit, 'state')
    let {
        control,
        register,
        handleSubmit,
        setValue,
        watch,
        reset,
        formState: { errors },
    } = useForm()

    const [addRequest, { isLoading: addLoading }] = useAddDocMutation()
    const [editRequest, { isLoading: editLoading }] = useEditDocMutation()

    const { data: data2 } = useGetSelectDriversQuery()
    const drivers = data2?.response?.data




    const onSubmit = async (data) => {
        // data['driver_id'] = data?.driver_id?.value > 0 ? data?.driver_id?.value : ''
        // data['job_time'] = data?.job_time && moment(data?.job_time, 'HH:mm').format('HH:mm')

        if (isEdit) {
            const newForm = convertToFormData({ driver_id: params?.id, ...data })
            await editRequest({ id: isEdit?.id, newForm }).unwrap()
                .then((res) => {
                    if (res?.status) {
                        sweetAlert(res?.message, 'success')
                        // navigate(-1)
                        handleClose()
                    }
                })
                .catch((err) => {
                    responseError(err)
                })
        } else {
            const newForm = convertToFormData({ driver_id: params?.id, ...data })
            await addRequest(newForm).unwrap()
                .then((res) => {
                    if (res?.status) {
                        sweetAlert(res?.message, 'success')
                        // navigate(-1)
                        handleClose()
                    }
                })
                .catch((err) => {
                    responseError(err)
                })
        }
    }

    return (
        <>
            <Modal show={show} onHide={() => handleClose()}>
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5">Add Driver Job</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit(onSubmit)} id='driver-status'>

                        <Form.Group className="mb-3">
                            <Form.Label>Name:</Form.Label>
                            <Controller
                                name="name"
                                control={control}
                                defaultValue={isEdit?.name || ''}
                                rules={{
                                    required: true
                                }}
                                render={({ field }) => (
                                    <Form.Control
                                        {...field}
                                        type="text"
                                        isInvalid={errors.name}
                                    />
                                )}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Doc File:</Form.Label>
                            <Controller
                                name="file"
                                control={control}
                                defaultValue={''}
                                rules={{
                                    required: isEdit?.file_url ? false : true
                                }}
                                render={({ field }) => (
                                    <Form.Control
                                        onChange={(e) => field.onChange(e.target.files[0])}
                                        type="file"
                                        isInvalid={errors.file}
                                    />
                                )}
                            />
                            {isEdit?.file_url && (
                                <a href={`${isEdit?.file_url}?download`} target='_blank' className='pt-2 d-block'>
                                    {isEdit?.file}
                                </a>
                            )}
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <LoadingButtonWithForm
                        isLoading={editLoading ? editLoading : addLoading}
                        name="Save"
                        form="driver-status"
                    />
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default DocAddModal;